import styles from "./Spinner.module.css";

interface SpinnerProps {
  label?: string;
  size?: "sm" | "md" | "lg";
  fullPage?: boolean;
}

export function Spinner({ label, size = "md", fullPage = false }: SpinnerProps) {
  return (
    <div className={`${styles.wrapper} ${fullPage ? styles.fullPage : ""}`}>
      <div className={`${styles.spinner} ${styles[size]}`} />
      {label && <p className={styles.label}>{label}</p>}
    </div>
  );
}
